declare const immer: {
    readonly immerable: unique symbol;
};
// #NOTE: [EM] This model shold also contain story type
export class StoryChapterThumbnail {
    [immer.immerable] = true;
    storyId: string;
    chapterId: string;
    urls: {
        small: string,
        large: string
    };
    snapshot?: string;
}
